import ConfigurablePosition from './_configurable-position.js'
import ConfigurableBackground from './_configurable-background.js'
import ConfigurableText from './_configurable-text.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableSize from './_configurable-size.js'
import Animation from './_animation.js'

export default {
  name: 'ScoreCount',
  values: {
    goalAnimationDuration: 2000,
    style: {
      goalContainer: {
        textAlign: 'center',
        transition: '.4s',
        right: 0,
        padding: '0 8px',
        minWidth: '100%',
        boxSizing: 'border-box',
        $mixin: [
          {
            configSet: ConfigurablePosition,
          },
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
          {
            configSet: ConfigurableSize,
          },
        ],
      },
      scoreText: {
        minWidth: '10px',
        textAlign: 'center',
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
    },
    animation: {
      configSet: Animation,
      configValues: {
        animationDuration: '.4s',
        animationTimingFunction: 'linear',
        animationIterationCount: '3',
        keyframes: {
          from: {
            opacity: '100%',
          },
          to: {
            opacity: '0%',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
